import React from 'react'
import Dashboard from '../Components/DashboardPage/Dashboard';

const DashBoardPage = () => {
  
  return (
    <div>
      <Dashboard/>
    </div>
  )
}

export default DashBoardPage;